// SettingAutostart.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import ModalSetBool from '../SettingPageComponents/ModalSetBool'
import ModalSetBool2 from '../SettingPageComponents/ModalSetBool2'
import colors from '../../../../css/colors.module.css'

export const SettingAutoModeHauff = function SettingAutoModeHauff ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  const CONTROLLER_STATE = (
    <FormattedMessage
      id='device.controllerState'
      defaultMessage='Controller State'
      description='Controller State Label'
    />
  )
  const MAN_SHORT = (
    <FormattedMessage
      id='setting.manual.short'
      defaultMessage='MAN'
      description='Auto Mode Man'
    />
  )
  const MAN_LONG = (
    <FormattedMessage
      id='setting.manual.long'
      defaultMessage='MANUAL'
      description='Auto Mode Manual'
    />
  )
  const AUTO_SHORT = (
    <FormattedMessage
      id='setting.auto.short'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  const AUTO_LONG = (
    <FormattedMessage
      id='setting.auto.long'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  let textPrimary = MAN_SHORT
  let textModal
  let textSave = MAN_LONG

  let tileColorAuto = colors.normal
  let intendedSetting = 0
  let settingStatusNew = 0
  const reading0 = device.reading0 || {}
  const applicationSettings = device.application_settings || { settings: {} }
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    applicationSettingsNew.status === 'new' &&
    (applicationSettingsNew.settings.auto === 1 ||
     applicationSettingsNew.settings.auto === 0)
  ) {
    intendedSetting = applicationSettingsNew.settings.auto ? 1 : 0
    settingStatusNew = 1
  } else if (
    applicationSettings &&
    applicationSettings.settings &&
    (
      applicationSettings.settings.auto === 1 ||
      applicationSettings.settings.auto === 0
    )
  ) {
    intendedSetting = applicationSettings.settings.auto ? 1 : 0
  }

  let controllerStatusAuto = 1
  if (
    device &&
    device.physical &&
    device.physical.sensorAutoSwitch !== false
  ) {
    controllerStatusAuto = reading0['143'] > 9000 ? 1 : 0
  }
  if (status.id === 'notConnected') {
    textPrimary = (<span className='fa fa-wifi fa-2x' />)
    textModal = (
      <FormattedMessage
        id='setting.auto.disconnected'
        defaultMessage='Altrac is disconnected. Click {mode} below to change controller mode when Altrac wakes'
        description='Auto mode change disconnected'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorAuto = colors.deviceProblem
  } else if (controllerStatusAuto === 1) {
    textPrimary = intendedSetting ? AUTO_SHORT : MAN_SHORT
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorAuto = colors.normal
  } else {
    textPrimary = intendedSetting ? AUTO_SHORT : MAN_SHORT
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorAuto = colors.disconnected
  }

  return (
    <ModalSetBool
      key='settingAutoMode'
      name='settingAutoMode'
      textPrimary={textPrimary}
      textSecondary={CONTROLLER_STATE}
      textModal={textModal}
      textSave={textSave}
      tileColor={settingStatusNew ? colors.deviceProblem : tileColorAuto}
      settingName='auto'
      settingNewValue={intendedSetting ? 0 : 1}
      address={reading0.address}
      warning={!intendedSetting}
      warningText={(
        <FormattedMessage
          id='setting.auto.warning'
          defaultMessage='Auto enables the machine to start automatically and without warning. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Auto mode warning'
        />
      )}
      enable={level >= 10}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingAutoModeHauff.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingAutoModeAmarillo = function SettingAutoModeAmarillo ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  const CONTROLLER_STATE = (
    <FormattedMessage
      id='device.controllerState'
      defaultMessage='Controller State'
      description='Controller State Label'
    />
  )
  const MAN_SHORT = (
    <FormattedMessage
      id='setting.manual.short'
      defaultMessage='MAN'
      description='Auto Mode Man'
    />
  )
  const MAN_LONG = (
    <FormattedMessage
      id='setting.manual.long'
      defaultMessage='MANUAL'
      description='Auto Mode Manual'
    />
  )
  const AUTO_SHORT = (
    <FormattedMessage
      id='setting.auto.short'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  const AUTO_LONG = (
    <FormattedMessage
      id='setting.auto.long'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  let textPrimary = MAN_SHORT
  let textModal
  let textSave = MAN_LONG

  let tileColorAuto = colors.normal
  let intendedSetting = 0
  let settingStatusNew = 0
  const reading0 = device.reading0 || {}
  const applicationSettings = device.application_settings || { settings: {} }
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    applicationSettingsNew.status === 'new' &&
    (applicationSettingsNew.settings.auto === 1 ||
     applicationSettingsNew.settings.auto === 0)
  ) {
    intendedSetting = applicationSettingsNew.settings.auto ? 1 : 0
    settingStatusNew = 1
  } else if (
    applicationSettings &&
    applicationSettings.settings &&
    (
      applicationSettings.settings.auto === 1 ||
      applicationSettings.settings.auto === 0
    )
  ) {
    intendedSetting = applicationSettings.settings.auto ? 1 : 0
  }

  const controllerStatusAuto = ((reading0['144'] & 0xFF) >>> 0) - 10
  if (status.id === 'notConnected') {
    textPrimary = (<span className='fa fa-wifi fa-2x' />)
    textModal = (
      <FormattedMessage
        id='setting.auto.disconnected'
        defaultMessage='Altrac is disconnected. Click {mode} below to change controller mode when Altrac wakes'
        description='Auto mode change disconnected'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorAuto = colors.deviceProblem
  } else if (controllerStatusAuto === 1) {
    textPrimary = intendedSetting ? AUTO_SHORT : MAN_SHORT
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorAuto = colors.normal
  } else {
    textPrimary = intendedSetting ? AUTO_SHORT : MAN_SHORT
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorAuto = colors.disconnected
  }

  return (
    <ModalSetBool
      key='settingAutoMode'
      name='settingAutoMode'
      textPrimary={textPrimary}
      textSecondary={CONTROLLER_STATE}
      textModal={textModal}
      textSave={textSave}
      tileColor={settingStatusNew ? colors.deviceProblem : tileColorAuto}
      settingName='auto'
      settingNewValue={intendedSetting ? 0 : 1}
      address={reading0.address}
      warning={!intendedSetting}
      warningText={(
        <FormattedMessage
          id='setting.auto.warning'
          defaultMessage='Auto enables the machine to start automatically and without warning. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Auto mode warning'
        />
      )}
      enable={level >= 10}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingAutoModeAmarillo.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingAutoModePump = function SettingAutoModePump ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  let settingStatusNew = 0
  const reading0 = device.reading0 || {}
  const applicationSettingsNew = device.application_settings_new || { settings: {} }

  const controllerStatusAuto = reading0['143'] > 9000 ? 1 : 0

  const CONTROLLER_STATE = (
    <FormattedMessage
      id='device.controllerState'
      defaultMessage='Controller State'
      description='Controller State Label'
    />
  )
  const MAN_SHORT = (
    <FormattedMessage
      id='setting.manual.short'
      defaultMessage='MAN'
      description='Auto Mode Man'
    />
  )
  const MAN_LONG = (
    <FormattedMessage
      id='setting.manual.long'
      defaultMessage='MANUAL'
      description='Auto Mode Manual'
    />
  )
  const AUTO_SHORT = (
    <FormattedMessage
      id='setting.auto.short'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  const AUTO_LONG = (
    <FormattedMessage
      id='setting.auto.long'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  let textPrimary = MAN_SHORT
  let textModal = (
    <FormattedMessage
      id='setting.auto.change'
      defaultMessage='Change controller mode to {mode}?'
      description='Auto mode change'
      values={{
        mode: MAN_LONG,
      }}
    />
  )
  let textSave = MAN_LONG

  let tileColorAuto = colors.normal

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    applicationSettingsNew.status === 'new' &&
    (applicationSettingsNew.settings.auto === 1 || applicationSettingsNew.settings.auto === 0)
  ) {
    settingStatusNew = 1
  }

  if (status.id === 'notConnected') {
    textPrimary = (<span className='fa fa-wifi fa-2x' />)
    textModal = (
      <FormattedMessage
        id='setting.auto.disconnected'
        defaultMessage='Altrac is disconnected. Click {mode} below to change controller mode when Altrac wakes'
        description='Auto mode change disconnected'
        values={{
          mode: MAN_LONG,
        }}
      />
    )
    textSave = 'MANUAL'
    tileColorAuto = colors.deviceProblem
  } else if (controllerStatusAuto === 1) {
    tileColorAuto = colors.normal
  } else {
    tileColorAuto = colors.disconnected
  }

  return (
    <ModalSetBool
      key='settingAutoMode'
      name='settingAutoMode'
      textPrimary={textPrimary}
      textSecondary='Controller State'
      textModal={textModal}
      textSave={textSave}
      tileColor={settingStatusNew ? colors.deviceProblem : tileColorAuto}
      settingName='auto'
      settingNewValue={0}
      address={reading0.address}
      warning={false}
      warningText={(
        <FormattedMessage
          id='setting.auto.warning'
          defaultMessage='Auto enables the machine to start automatically and without warning. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Auto mode warning'
        />
      )}
      enable={false}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingAutoModePump.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingAutoModePump1 = function SettingAutoModePump1 ({
  device,
  status,
  level,
  customer,
  pinCode,
  number = 1,
}) {
  const CONTROLLER_STATE = (
    <FormattedMessage
      id='device.controllerState'
      defaultMessage='Controller State'
      description='Controller State Label'
    />
  )
  const MAN_SHORT = (
    <FormattedMessage
      id='setting.manual.short'
      defaultMessage='MAN'
      description='Auto Mode Man'
    />
  )
  const MAN_LONG = (
    <FormattedMessage
      id='setting.manual.long'
      defaultMessage='MANUAL'
      description='Auto Mode Manual'
    />
  )
  const AUTO_SHORT = (
    <FormattedMessage
      id='setting.auto.short'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  const AUTO_LONG = (
    <FormattedMessage
      id='setting.auto.long'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  let textLeft = MAN_SHORT
  let textRight = AUTO_SHORT
  let textModal
  let textSave = MAN_LONG

  let tileColorLeft = colors.normal
  let tileColorRight = colors.normal
  let intendedSetting = 0
  let settingStatusNew = 0
  const reading0 = device.reading0 || {}
  const applicationSettings = device.application_settings || { settings: {} }
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  const autoSetting = 'auto'
  const autoSettingConfirm = '202'
  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    applicationSettingsNew.status === 'new' &&
    (applicationSettingsNew.settings[autoSetting] === 1 ||
      applicationSettingsNew.settings[autoSetting] === 0)
  ) {
    intendedSetting = applicationSettingsNew.settings[autoSetting] ? 1 : 0
    settingStatusNew = 1
  } else if (
    typeof reading0[autoSettingConfirm] !== 'undefined' &&
    (reading0[autoSettingConfirm] === 0 || reading0[autoSettingConfirm] === 1) &&
    reading0.date > applicationSettings.date
  ) {
    intendedSetting = reading0[autoSettingConfirm] ? 1 : 0
  } else if (
    applicationSettings &&
    applicationSettings.settings &&
    (
      applicationSettings.settings[autoSetting] === 1 ||
      applicationSettings.settings[autoSetting] === 0
    )
  ) {
    intendedSetting = applicationSettings.settings[autoSetting] ? 1 : 0
  }

  let controllerStatusAuto = 1
  if (
    device &&
    device.physical &&
    device.physical.sensorAutoSwitch !== false
  ) {
    controllerStatusAuto = reading0['143'] > 0 ? 1 : 0
  }
  if (status.id === 'notConnected') {
    textLeft = (<span className='fa fa-wifi fa-2x' />)
    textRight = (<span className='fa fa-wifi fa-2x' />)
    textModal = (
      <FormattedMessage
        id='setting.auto.disconnected'
        defaultMessage='Altrac is disconnected. Click {mode} below to change controller mode when Altrac wakes'
        description='Auto mode change disconnected'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorLeft = colors.deviceProblem
    tileColorRight = colors.deviceProblem
  } else if (controllerStatusAuto === 1) {
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorLeft = colors.normal
    tileColorRight = colors.normal
  } else {
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorLeft = colors.normal
    tileColorRight = colors.normal
  }

  return (
    <ModalSetBool2
      key='settingAutoMode'
      name='settingAutoMode'
      textLeft={textLeft}
      textRight={textRight}
      textSub='Mode'
      textModal={textModal}
      textSave={textSave}
      tileColorLeft={settingStatusNew ? colors.deviceProblem : tileColorLeft}
      tileColorRight={settingStatusNew ? colors.deviceProblem : tileColorRight}
      settingName={autoSetting}
      settingCurrentValue={intendedSetting ? 1 : 0}
      settingNewValue={intendedSetting ? 0 : 1}
      address={reading0.address}
      warning={!intendedSetting}
      warningText={(
        <FormattedMessage
          id='setting.auto.warning'
          defaultMessage='Auto enables the machine to start automatically and without warning. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Auto mode warning'
        />
      )}
      enable={level >= 10}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingAutoModePump1.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingAutoModePump2 = function SettingAutoModePump2 ({
  device,
  status,
  level,
  customer,
  pinCode,
  number = 1,
}) {
  const CONTROLLER_STATE = (
    <FormattedMessage
      id='device.controllerState'
      defaultMessage='Controller State'
      description='Controller State Label'
    />
  )
  const MAN_SHORT = (
    <FormattedMessage
      id='setting.manual.short'
      defaultMessage='MAN'
      description='Auto Mode Man'
    />
  )
  const MAN_LONG = (
    <FormattedMessage
      id='setting.manual.long'
      defaultMessage='MANUAL'
      description='Auto Mode Manual'
    />
  )
  const AUTO_SHORT = (
    <FormattedMessage
      id='setting.auto.short'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  const AUTO_LONG = (
    <FormattedMessage
      id='setting.auto.long'
      defaultMessage='AUTO'
      description='Auto Mode Auto'
    />
  )
  let textLeft = MAN_SHORT
  let textRight = AUTO_SHORT
  let textModal
  let textSave = MAN_LONG

  let tileColorLeft = colors.normal
  let tileColorRight = colors.normal
  let intendedSetting = 0
  let settingStatusNew = 0
  const reading0 = device.reading0 || {}
  const applicationSettings = device.application_settings || { settings: {} }
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  const autoSetting = `auto${number}`
  const autoSettingConfirm = `X${number === 1 ? 'A' : 'B'}`
  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    applicationSettingsNew.status === 'new' &&
    (applicationSettingsNew.settings[autoSetting] === 1 ||
      applicationSettingsNew.settings[autoSetting] === 0)
  ) {
    intendedSetting = applicationSettingsNew.settings[autoSetting] ? 1 : 0
    settingStatusNew = 1
  } else if (
    typeof reading0[autoSettingConfirm] !== 'undefined' &&
    (reading0[autoSettingConfirm] === 0 || reading0[autoSettingConfirm] === 1) &&
    reading0.date > applicationSettings.date
  ) {
    intendedSetting = reading0[autoSettingConfirm] ? 1 : 0
  } else if (
    applicationSettings &&
    applicationSettings.settings &&
    (
      applicationSettings.settings[autoSetting] === 1 ||
      applicationSettings.settings[autoSetting] === 0
    )
  ) {
    intendedSetting = applicationSettings.settings[autoSetting] ? 1 : 0
  }

  let controllerStatusAuto = 1
  if (
    device &&
    device.physical &&
    device.physical.sensorAutoSwitch !== false
  ) {
    controllerStatusAuto = reading0.DI1 > 0 ? 1 : 0
  }
  if (status.id === 'notConnected') {
    textLeft = (<span className='fa fa-wifi fa-2x' />)
    textRight = (<span className='fa fa-wifi fa-2x' />)
    textModal = (
      <FormattedMessage
        id='setting.auto.disconnected'
        defaultMessage='Altrac is disconnected. Click {mode} below to change controller mode when Altrac wakes'
        description='Auto mode change disconnected'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorLeft = colors.deviceProblem
    tileColorRight = colors.deviceProblem
  } else if (controllerStatusAuto === 1) {
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorLeft = colors.normal
    tileColorRight = colors.normal
  } else {
    textModal = (
      <FormattedMessage
        id='setting.auto.change'
        defaultMessage='Change controller mode to {mode}?'
        description='Auto mode change'
        values={{
          mode: intendedSetting ? MAN_LONG : AUTO_LONG,
        }}
      />
    )
    textSave = intendedSetting ? MAN_LONG : AUTO_LONG
    tileColorLeft = colors.normal
    tileColorRight = colors.normal
  }

  return (
    <ModalSetBool2
      key='settingAutoMode'
      name='settingAutoMode'
      textLeft={textLeft}
      textRight={textRight}
      textSub='Mode'
      textModal={textModal}
      textSave={textSave}
      tileColorLeft={settingStatusNew ? colors.deviceProblem : tileColorLeft}
      tileColorRight={settingStatusNew ? colors.deviceProblem : tileColorRight}
      settingName={autoSetting}
      settingCurrentValue={intendedSetting ? 1 : 0}
      settingNewValue={intendedSetting ? 0 : 1}
      address={reading0.address}
      warning={!intendedSetting}
      warningText={(
        <FormattedMessage
          id='setting.auto.warning'
          defaultMessage='Auto enables the machine to start automatically and without warning. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Auto mode warning'
        />
      )}
      enable={level >= 10}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingAutoModePump2.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}
